/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityDashboardVulnerabilityMonth {
    getFixupPrototypeFunction() { return SecurityDashboardVulnerabilityMonth.fixupPrototype; }

    static newInstance(model: Partial<SecurityDashboardVulnerabilityMonth>): SecurityDashboardVulnerabilityMonth {
        let obj = Object.assign(new SecurityDashboardVulnerabilityMonth(), model);
        SecurityDashboardVulnerabilityMonth.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityDashboardVulnerabilityMonth>): SecurityDashboardVulnerabilityMonth {
        if (!model) return null;
        return SecurityDashboardVulnerabilityMonth.newInstance(<SecurityDashboardVulnerabilityMonth> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityDashboardVulnerabilityMonth) {
        if (!obj) return;

        models.SecurityDashboardVulnerabilityMonth.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityDashboardVulnerabilityMonth): boolean {
        Object.setPrototypeOf(obj, SecurityDashboardVulnerabilityMonth.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.count_by_severity) {
            models.SecurityDashboardSeverity.fixupPrototype(this.count_by_severity);
        }
    }

    /**
     * Vulnerability Month
     */
    month: string;

    /**
     * Vulnerability Severity Values
     */
    count_by_severity: models.SecurityDashboardSeverity;

}
